import React from 'react'
import { connect } from 'react-redux'
import { Field, formValueSelector } from 'redux-form'
import { Input, Select } from '../../../../../../../../../../itrust_common/components/form'
import { required } from '../../../../../../../../../../itrust_common/components/form/FormValidations'
import shape1 from '../../../../../../../../../../assets/static/images/eyemed/d_frm_1.gif'
import shape2 from '../../../../../../../../../../assets/static/images/eyemed/d_frm_2.gif'
import shape3 from '../../../../../../../../../../assets/static/images/eyemed/d_frm_3.gif'
import shape4 from '../../../../../../../../../../assets/static/images/eyemed/d_frm_4.gif'
import shape5 from '../../../../../../../../../../assets/static/images/eyemed/d_frm_5.gif'
import shape6 from '../../../../../../../../../../assets/static/images/eyemed/d_frm_6.gif'
import shape7 from '../../../../../../../../../../assets/static/images/eyemed/d_frm_7.gif'
import shape8 from '../../../../../../../../../../assets/static/images/eyemed/d_frm_8.gif'
import measureABox from '../../../../../../../../../../assets/static/images/eyemed/measure_a_box.svg'
import measureBBox from '../../../../../../../../../../assets/static/images/eyemed/measure_b_box.svg'
import measureDbl from '../../../../../../../../../../assets/static/images/eyemed/measure_dbl.svg'
import measureEd from '../../../../../../../../../../assets/static/images/eyemed/measure_ed.svg'

const STANDARD_SHAPES = [
  { number: 1, src: shape1 },
  { number: 2, src: shape2 },
  { number: 3, src: shape3 },
  { number: 4, src: shape4 },
  { number: 5, src: shape5 },
  { number: 6, src: shape6 },
  { number: 7, src: shape7 },
  { number: 8, src: shape8 },
]

const THICKNESS_TYPE_OPTIONS = [
  { label: 'Lab decides best thickness', value: 'Lab decides best thickness' },
  { label: 'Center thickness', value: 'Center thickness' },
  { label: 'Thickness at drilling point', value: 'Thickness at drilling point' },
]

const BASE_CURVE_OPTIONS = [
  { label: 'No', value: 'No' },
  { label: 'Yes', value: 'Yes' },
]

const FRAME_TYPE_OPTIONS = [
  { label: 'Metal Edge', value: 'Metal Edge' },
  { label: 'Metal 1/2 Eye', value: 'Metal 1/2 Eye' },
  { label: 'Zyl Edge', value: 'Zyl Edge' },
  { label: 'Zyl 1/2 Eye', value: 'Zyl 1/2 Eye' },
  { label: 'Grooved Rimless', value: 'Grooved Rimless' },
  { label: 'Drilled Rimless', value: 'Drilled Rimless' },
  { label: 'Drill 2 Holes', value: 'Drill 2 Holes' },
  { label: 'Drill 4 Holes', value: 'Drill 4 Holes' },
  { label: 'Drill 6 Holes', value: 'Drill 6 Holes' },
  { label: 'Drill 8 Holes', value: 'Drill 8 Holes' },
]

const FRAME_ATTRIBUTE_FIELDS = [
  { name: 'frame_attributes.manufacturer', label: 'Manufacturer:', required: true },
  { name: 'frame_attributes.brand', label: 'Brand:', required: true },
  { name: 'frame_attributes.model', label: 'Model:', required: true },
  { name: 'frame_attributes.color', label: 'Color:', required: true },
  { name: 'frame_attributes.eye_size', label: 'Eye Size (mm):', required: true },
  { name: 'frame_attributes.temple_length', label: 'Temple Length (mm):', required: false },
  { name: 'frame_attributes.sku', label: 'SKU:', required: false },
]

const MEASUREMENT_FIELDS = [
  { name: 'a_box', label: 'A Box (mm)', required: true, icon: measureABox },
  { name: 'b_box', label: 'B Box (mm)', required: true, icon: measureBBox },
  { name: 'dbl', label: 'DBL (mm)', required: true, icon: measureDbl },
  { name: 'ed', label: 'ED (mm)', required: false, icon: measureEd },
]

const onlyNumber = (value) => (value == null || value === '' ? value : String(value).replace(/[^\d.-]/g, ''))

function StandardShapeField({ input }) {
  return (
    <div className="d-flex flex-wrap lenses-standard-shapes">
      {STANDARD_SHAPES.map(({ number, src }) => {
        const value = String(number)
        const selected = input.value === value
        return (
          <button
            key={value}
            type="button"
            className={`lenses-shape-option ${selected ? 'selected' : ''}`}
            onClick={() => input.onChange(value)}
          >
            {selected && <span className="lenses-shape-check">✓</span>}
            <img src={src} alt={`Shape ${number}`} className="lenses-shape-img" />
            <span className="lenses-shape-number">{number}</span>
          </button>
        )
      })}
    </div>
  )
}

function FrameAttributesSection() {
  return (
    <div className="mb-5">
      <div className="d-flex align-items-center mb-4">
        <label className="mb-0 mr-3 text-nowrap font-weight-bold">Specify Base Curve?</label>
        <div style={{ width: '8rem' }}>
          <Field
            name="specify_base_curve"
            component={Select}
            data={BASE_CURVE_OPTIONS}
            textField="label"
            valueField="value"
            className="custom-select"
            wrapperClasses="mb-0"
          />
        </div>
      </div>
      <h5 className="mb-4 font-weight-bold">Frame Attributes</h5>
      <div className="col-8 px-0">
        {FRAME_ATTRIBUTE_FIELDS.map(({ name, label, required: isRequired }) => (
          <div key={name} className="d-flex align-items-center mb-3">
            <label className="mb-0 mr-3 text-nowrap" style={{ minWidth: '9.5rem' }}>{label}</label>
            <Field
              name={name}
              component={Input}
              className="form-control"
              wrapperClasses="mb-0 flex-grow-1"
              normalize={name.includes('eye_size') || name.includes('temple_length') ? onlyNumber : undefined}
              validate={isRequired ? [required] : []}
            />
            {isRequired && <span className="text-danger ml-2">*</span>}
          </div>
        ))}
      </div>
    </div>
  )
}

function MeasurementSection() {
  return (
    <div className="lenses-measure-grid mb-5">
      {MEASUREMENT_FIELDS.map(({ name, label, required: isRequired, icon }) => (
        <div key={name} className="lenses-measure-cell">
          <div className="lenses-measure-header" />
          <div className="lenses-measure-body">
            <Field
              name={name}
              component={Input}
              className="form-control form-control-sm"
              wrapperClasses="mb-2"
              normalize={onlyNumber}
              validate={isRequired ? [required] : []}
            />
            <div className="lenses-measure-label">
              {label}{isRequired ? '*' : ''}
            </div>
            <img src={icon} alt={label} className="lenses-measure-icon" />
          </div>
        </div>
      ))}
    </div>
  )
}

function LensFrameDetailsFields({ isLabType, thicknessType }) {
  const showThicknessInputs = isLabType
    && thicknessType
    && thicknessType !== 'Lab decides best thickness'

  return (
    <div className="border rounded p-5 mt-4">
      {isLabType && (
        <>
          <FrameAttributesSection />
          <MeasurementSection />
        </>
      )}

      <h6 className="mb-4 font-weight-bold">Select Standard Shape</h6>
      <Field name="standard_shape" component={StandardShapeField} />

      <h6 className="mb-4 mt-5 font-weight-bold">Frame Details</h6>
      <div className="col-8 px-0">
        <div className="d-flex align-items-center mb-4">
          <label className="mb-0 mr-3 text-nowrap" style={{ minWidth: '7.5rem' }}>Frame Type:</label>
          <Field
            name="frame_type"
            component={Select}
            data={FRAME_TYPE_OPTIONS}
            textField="label"
            valueField="value"
            placeholder="--- Select a Frame Type----"
            className="custom-select"
            wrapperClasses="mb-0 flex-grow-1"
            validate={[required]}
          />
          <span className="text-danger ml-2">*</span>
        </div>

        {isLabType && (
          <>
            <div className="d-flex align-items-center mb-4">
              <label className="mb-0 mr-3 text-nowrap" style={{ minWidth: '7.5rem' }}>Thickness Type:</label>
              <Field
                name="thickness_type"
                component={Select}
                data={THICKNESS_TYPE_OPTIONS}
                textField="label"
                valueField="value"
                className="custom-select"
                wrapperClasses="mb-0 flex-grow-1"
              />
            </div>
            {showThicknessInputs && (
              <div className="d-flex">
                <div className="mr-6">
                  <label className="d-block mb-2">Thickness (RE) mm</label>
                  <div className="d-flex align-items-center">
                    <Field
                      name="thickness_re"
                      component={Input}
                      className="form-control"
                      wrapperClasses="mb-0"
                      normalize={onlyNumber}
                      validate={[required]}
                    />
                    <span className="text-danger ml-2">*</span>
                  </div>
                </div>
                <div>
                  <label className="d-block mb-2">Thickness (LE) mm</label>
                  <div className="d-flex align-items-center">
                    <Field
                      name="thickness_le"
                      component={Input}
                      className="form-control"
                      wrapperClasses="mb-0"
                      normalize={onlyNumber}
                      validate={[required]}
                    />
                    <span className="text-danger ml-2">*</span>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

const selector = formValueSelector('EyeMedClaimForm')

export default connect((state) => ({
  thicknessType: selector(state, 'lenses.thickness_type'),
}))(LensFrameDetailsFields)
